import { Link } from "react-router-dom";
import type { Drama } from "@/mocks/dramas";
import DramaCard from "@/components/feature/DramaCard";

type DramaShelfProps = {
  headingId: string;
  title: string;
  subtitle?: string;
  dramas: Drama[];
  moreHref?: string;
  moreLabel?: string;
  ranked?: boolean;
};

export default function DramaShelf({
  headingId,
  title,
  subtitle,
  dramas,
  moreHref,
  moreLabel = "查看全部",
  ranked = false,
}: DramaShelfProps) {
  return (
    <section aria-labelledby={headingId} className="mt-12 md:mt-16">
      <div className="mb-4 flex flex-wrap items-end justify-between gap-3 md:mb-6">
        <div>
          <h2
            id={headingId}
            className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-50 md:text-2xl"
          >
            <span className="h-5 w-1 rounded-full bg-gradient-to-b from-primary-300 to-accent-500 md:h-6" />
            {title}
          </h2>
          {subtitle && <p className="mt-1.5 pl-3 text-xs text-foreground-500 md:text-sm">{subtitle}</p>}
        </div>
        {moreHref && (
          <Link
            to={moreHref}
            className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-foreground-400 transition-colors hover:text-primary-300 md:text-sm"
          >
            {moreLabel}
            <i className="ri-arrow-right-s-line text-base" aria-hidden="true" />
          </Link>
        )}
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4 md:gap-5 xl:grid-cols-6">
        {dramas.map((drama, index) => (
          <DramaCard key={drama.id} drama={drama} rank={ranked ? index : undefined} />
        ))}
      </div>
    </section>
  );
}